<template>
  <div>
    <v-card elevation="1">
      <v-container fluid>
        <v-row>
          <v-col cols="12" sm="12" md="5" lg="5" xl="7">
            <span class="font-weight-light text-h5"
              >Buildings and Functional Unit Spaces</span
            >
          </v-col>
          <v-col cols="12" sm="12" md="3" lg="4" xl="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field
          ></v-col>

          <v-col cols="12" sm="12" md="4" lg="3" xl="2">
            <v-row justify="end">
              <v-col>
                <v-menu>
                  <template v-slot:activator="{ attrs, on }">
                    <v-btn
                      :disabled="saveAssetsDisabled"
                      color="primary"
                      v-bind="attrs"
                      v-on="on"
                    >
                      Actions <i class="material-icons">arrow_drop_down</i>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="(item, index) in selectedBuildingsOptions"
                      :key="index"
                      :value="item.title"
                      @change="handleSelection(item.title)"
                      link
                    >
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-col>
              <v-col>
                <v-btn color="success" @click="handleNewBuilding"
                  >Add new</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>

      <v-data-table
        v-if="!loadingData"
        v-model="selected"
        :headers="headers"
        :items="buildings"
        :single-select="singleSelect"
        :search="search"
        item-key="id"
        show-select
        class="elevation-1"
      >
        <template v-slot:item.sri="{ item }">
          <span v-if="!item.sri">Scores not saved</span>
          <v-row v-if="item.sri">
            <v-col sm="12" md="6" lg="1" class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex align-center">
                    <img
                      :src="require(`@/assets/svg/${item.sri.sri_grade}.svg`)"
                      style="width: 38px; height: 38px"
                    />
                  </div>
                </template>
                <span>Overall SRI <br />score</span>
              </v-tooltip>
            </v-col>
            <v-col sm="12" md="6" lg="3" offset-lg="1">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex align-center">
                    <img
                      :src="require(`@/assets/ao.png`)"
                      class="scores-icon"
                    />
                    <span class="percentage-text"
                      >{{
                        Math.round(
                          item.sri.key_functionality_scores
                            .ADAPTABILITY_OCCUPANT * 100
                        )
                      }}%</span
                    >
                  </div>
                </template>
                <span
                  >Ability to adapt its<br />
                  operation to the needs<br />
                  of the occupant</span
                >
              </v-tooltip>
            </v-col>
            <v-col sm="12" md="6" lg="3" class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex align-center">
                    <img
                      :src="require(`@/assets/asg.png`)"
                      class="scores-icon"
                    />
                    <span class="percentage-text"
                      >{{
                        Math.round(
                          item.sri.key_functionality_scores
                            .ADAPTABILITY_SIGNAL_GRID * 100
                        )
                      }}%</span
                    >
                  </div>
                </template>
                <span
                  >Ability to adapt to <br />signals from the grid <br />
                  (energy flexibility)</span
                >
              </v-tooltip>
            </v-col>
            <v-col sm="12" md="6" lg="3" class="d-flex align-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="d-flex align-center">
                    <img
                      :src="require(`@/assets/ee.png`)"
                      class="scores-icon"
                    />
                    <span class="percentage-text"
                      >{{
                        Math.round(
                          item.sri.key_functionality_scores.ENERGY_EFFICIENCY *
                            100
                        )
                      }}%</span
                    >
                  </div>
                </template>
                <span
                  >Ability to optimise energy <br />efficiency and overall
                  <br />inuse performance</span
                >
              </v-tooltip>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.assets="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-on="on"
                v-bind="attrs"
                :color="item.assets > 0 ? 'green' : 'red'"
                >mdi-check-circle</v-icon
              >
            </template>
            <span>{{ `${item.assets} datasets uploaded` }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <template>
            <v-menu left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" icon>
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  v-for="(option, index) in options"
                  :key="index"
                  @click="handleAction(item.id, option.title)"
                >
                  <v-list-item-content>
                    <v-list-item-title>{{ option.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </template>
      </v-data-table>
      <table-skeleton-loader v-else :loading="loadingData" />

      <v-snackbar
        timeout="2000"
        :value="snackbarVisible"
        absolute
        color="success"
        top
      >
        <div class="text-center">
          <span>Table data refreshed successfully.</span>
        </div>
      </v-snackbar>
    </v-card>
  </div>
</template>

<script>
import services from "../rest/Services";
import router from "../router/index";
import utility from "../utility/utility";
import EventBus from "./EventBus";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import TableSkeletonLoader from "./TableSkeletonLoader.vue";

export default {
  components: { TableSkeletonLoader },
  props: { refreshParams: Object },
  mounted: function () {
    EventBus.$on("savedSriScore", () => {
      this.getFunctionalUnits({});
    });
    EventBus.$on("saveBuildingSuccess", () => {
      this.getFunctionalUnits({});
    });
    EventBus.$on("assetUploadSuccess", () => {
      this.getFunctionalUnits({});
    });
  },
  activated() {
    this.getFunctionalUnits({});
  },
  data() {
    return {
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "Country",
          value: "country",
        },
        {
          text: "Building adress",
          value: "adress",
        },
        { text: "Smart readiness rating", value: "sri", width: 450 },
        {
          text: "Functional unit type",
          value: "functional_unit_type",
        },
        { text: "Building usage", value: "building_type_usage" },
        { text: "Floor area (m2)", value: "floor_area" },
        { text: "Assets", value: "assets", align: "end" },
        { text: "Actions", value: "actions", align: "end" },
      ],
      buildings: [],
      editDisabled: true,
      functionalUnits: [],
      snackbarVisible: false,
      options: [{ title: "Edit" }, { title: "Explore" }],
      saveAssetsDisabled: true,
      selectedBuildingsOptions: [
        { title: "Save Assets" },
        { title: "Upload Assets" },
        { title: "Comparative Overview" },
      ],
      selectedOption: null,
      loadingData: true,
    };
  },
  methods: {
    handleSaveAssets: function () {
      this.$emit("saveAssets", this.selected);
    },
    handleUploadAssets: function () {
      this.$emit("uploadAssets", this.selected);
    },
    handleSelection(value) {
      if (value === "Save Assets") {
        this.handleSaveAssets();
      } else if (value === "Comparative Overview") {
        this.handleComparativeOverview();
      } else if (value === "Upload Assets") {
        this.handleUploadAssets();
      }
    },
    getFunctionalUnits: function (params) {
      this.loadingData = true;
      services
        .getFunctionalUnits(params)
        .then((response) => {
          this.functionalUnits = response.data.data;
          this.setBuildingsData();
          this.loadingData = false;
        })
        .catch((error) => {
          console.log("Error while getting functional units", error);
          this.loadingData = false;
        });
    },

    setBuildingsData: function () {
      let buildings = [];
      this.functionalUnits.forEach((object) => {
        let { functional_unit: fUnit, score, asset_ids } = object;
        buildings.push({
          id: fUnit.id,
          country: `${fUnit.address_data.country}`,
          adress: `${fUnit.address_data.street} ${fUnit.address_data.street_number}, ${fUnit.address_data.city}`,
          sri: score,
          functional_unit_type: utility.convertStrToLabel(
            fUnit.functional_unit_type
          ),
          building_type_usage: utility.convertStrToLabel(
            fUnit.building_type_usage
          ),
          floor_area: fUnit.floor_area,
          assets: asset_ids ? asset_ids.length : 0,
        });
      });
      this.buildings = buildings;
      this.showSnackbar();
    },
    handleNewBuilding() {
      this.$emit("newBuilding");
    },
    handleComparativeOverview() {
      this.$emit(
        "comparativeOverview",
        this.selected.map((obj) => obj.id)
      );
    },

    showSnackbar() {
      this.snackbarVisible = true;
      setTimeout(() => {
        this.snackbarVisible = false;
      }, 2000);
    },
    handleAction(id, action) {
      switch (action) {
        case "Edit":
          this.getPermission(id);
          break;
        case "Explore": {
          const selectedFunit = this.functionalUnits.find(
            (funit) => funit.functional_unit.id === id
          );
          localStorage.setItem(
            "asset_ids",
            JSON.stringify(selectedFunit.asset_ids || null)
          );
          router.push({
            name: "Building",
            params: { buildingId: id },
          });
          break;
        }
        default:
          break;
      }
    },
    getPermission(id) {
      if (utility.checkIfAdmin()) {
        this.$emit("editBuilding", id);
        return;
      }
      utility.getPermission(id).then((permission) => {
        permission
          ? this.$emit("editBuilding", id)
          : this.$emit(
              "editDenied",
              "Current user doesn't have the permission for this action."
            );
      });
    },
  },
  watch: {
    selected: function (value) {
      if (value.length > 0) {
        this.saveAssetsDisabled = false;
      } else this.saveAssetsDisabled = true;
    },
    refreshParams: function (params) {
      this.getFunctionalUnits(params);
    },
  },
};
</script>

<style>
.percentage-text {
  font-size: 24px;
  font-weight: bold;
  color: gray;
  margin-left: 5px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}
.scores-icon {
  width: 32px;
  height: 32px;
}
</style>
